export const EnvironmentIndicator = () => {
  const environment = import.meta.env.VITE_ENVIRONMENT;
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  
  if (environment === 'production') {
    return null; // Hide in production
  }
  
  return (
    <div className="fixed top-0 right-0 bg-yellow-500 text-black p-2 text-xs z-50">
      ENV: {environment} | DB: {supabaseUrl?.split('.')[0].split('//')[1]}
    </div>
  );
};